import { Show } from "../../domain/show";
import moment from "moment";
import Sorted from "sorted-array-functions";

function startTimeComparer(a: Show, b: Show): number {
  return Math.sign(a.startTime.valueOf() - b.startTime.valueOf());
}

function endTimeComparer(a: Show, b: Show): number {
  return Math.sign(a.endTime.valueOf() - b.endTime.valueOf());
}

export class ShowsCache {
  constructor(private shows: Show[]) {}

  getShowDuring(time) {
    if (this.shows.length === 0) {
      return null;
    }

    let index = Sorted.gt(this.shows, { startTime: time }, startTimeComparer);
    if (index === 0) {
      return null;
    }

    let lastItemThatStartBeforeOrInTime =
      index === -1 ? this.shows[this.shows.length - 1] : this.shows[index - 1];

    return lastItemThatStartBeforeOrInTime.endTime.isAfter(time)
      ? lastItemThatStartBeforeOrInTime
      : null;
  }

  getShowEndsBeforeOrAt(time: moment.Moment) {
    if (this.shows.length === 0) {
      return null;
    }
    let index = Sorted.gt(this.shows, { endTime: time }, endTimeComparer);
    if (index === -1) {
      return this.shows[this.shows.length - 1];
    }
    return index === 0 ? null : this.shows[index - 1];
  }

  getShowStartsAfterOrAt(time: moment.Moment) {
    let index = Sorted.gte(this.shows, { startTime: time }, startTimeComparer);
    return index > -1 ? this.shows[index] : null;
  }

  getShowsBetween(after: moment.Moment, before: moment.Moment) {
    if (this.shows.length === 0) {
      return null;
    }
    let start = Sorted.gte(this.shows, { startTime: after }, startTimeComparer);
    let end = Sorted.gt(this.shows, { endTime: before }, endTimeComparer);
    return start > -1
      ? end > -1
        ? this.shows.slice(start, end)
        : this.shows.slice(start)
      : null;
  }
}
